import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 bg-brand-light" data-id="element-8">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-10">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-8" data-id="element-11">
            About Us
          </h2>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-light" data-id="element-12">
            Modern Fix is a Los Angeles-based residential remodeling company
            focused on delivering clean, modern, and functional living spaces.
            We work directly with homeowners to bring their vision to life with
            quality craftsmanship and attention to detail.
          </p>

          <div className="mt-12 w-16 h-16 border border-brand-accent/20 rounded-full flex items-center justify-center mx-auto" data-id="element-13">
            <div className="w-2 h-2 bg-brand-accent rounded-full" data-id="element-14"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}